// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Social_social__7F64L {
  display: flex;
  flex-direction: column;
  width: 20rem;
  flex-shrink: 0;
}

.Social_social__address__ozEvd {
  font-size: var(--text-base);
  font-style: normal;
  font-weight: 500;
  color: #fff;
}

/* .social__line {
  height: 1px;
  background-color: #fff;
} */

/* .social__links {
  display: flex;
  align-items: center;
  gap: 3.7rem;
} */

@media screen and (min-width: 1024px) and (max-width: 1280px) {
  .Social_social__7F64L {
    width: 15rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Layout/DashboardFooter/Sitemap/Social/Social.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,2BAA2B;EAC3B,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;AACb;;AAEA;;;GAGG;;AAEH;;;;GAIG;;AAEH;EACE;IACE,YAAY;EACd;AACF","sourcesContent":[".social {\n  display: flex;\n  flex-direction: column;\n  width: 20rem;\n  flex-shrink: 0;\n}\n\n.social__address {\n  font-size: var(--text-base);\n  font-style: normal;\n  font-weight: 500;\n  color: #fff;\n}\n\n/* .social__line {\n  height: 1px;\n  background-color: #fff;\n} */\n\n/* .social__links {\n  display: flex;\n  align-items: center;\n  gap: 3.7rem;\n} */\n\n@media screen and (min-width: 1024px) and (max-width: 1280px) {\n  .social {\n    width: 15rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"social": `Social_social__7F64L`,
	"social__address": `Social_social__address__ozEvd`
};
export default ___CSS_LOADER_EXPORT___;
